<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre optimisation"
  [formGroup]="form"
>
  <pr-input-radio-round
    formControlName="propertyType"
    label="Type de bien"
    [options]="[
      { value: 'HOUSE', label: 'Maison' },
      { value: 'APPARTMENT', label: 'Appartement' },
    ]"
  >
  </pr-input-radio-round>

  <h3>Informations du bien</h3>

  <!-- <pr-input label="Estimation" suffix="€">
    <input formControlName="" type="text" />
  </pr-input> -->

  <pr-input label="Surface du bien" suffix="m2">
    <input formControlName="areaSize" type="number" />
  </pr-input>

  <pr-input label="Prix au m2" suffix="€">
    <input formControlName="priceAvg" type="number" />
  </pr-input>

  <pr-input label="Estimation" suffix="€">
    <input formControlName="estimation" type="number" />
  </pr-input>

  <pr-input label="Durée du projet" suffix="ans">
    <input formControlName="duration" type="number" />
  </pr-input>

  <pr-input label="Loyer mensuel" suffix="€">
    <input formControlName="rent" type="number" />
  </pr-input>

  <pr-input label="Revalorisation foncière" suffix="%">
    <input formControlName="rentalReversion" type="number" />
  </pr-input>

  <h3>Condition du marché</h3>

  <pr-input label="Durée de l’emprunt" suffix="ans">
    <input formControlName="loanDuration" type="number" />
  </pr-input>

  <pr-input label="Taux" suffix="%">
    <input formControlName="loanInterestRate" type="number" />
  </pr-input>

  <pr-input label="Taux de l'assurance" suffix="%">
    <input formControlName="loanInsuranceRate" type="number" />
  </pr-input>

  <pr-input label="Frais d'agence" suffix="%">
    <input formControlName="agencyFees" type="number" />
  </pr-input>

  <pr-input label="Frais de notaire" suffix="%">
    <input formControlName="notaryFees" type="number" />
  </pr-input>

  <pr-input label="Tax foncière" suffix="€/m2">
    <input formControlName="propertyTax" type="number" />
  </pr-input>

  <pr-input label="Charges annuelles" suffix="€/m2">
    <input formControlName="managementFees" type="number" />
  </pr-input>
</pr-form>
